'use strict'
require("babel-polyfill")
require("picturefill")
// var colorify = require('colorify.js');
import 'objectFitPolyfill';
import 'url-polyfill'
import 'nodelist-foreach-polyfill'

import ScrollTrigger from '@terwanerik/scrolltrigger'
// import 'hammerjs'
// import 'custom-event-polyfill'
import $ from "expose-loader?exposes=$,jQuery!jquery";

import Swiper from 'swiper/bundle'
import Rellax from 'Rellax'
// import Vue from 'vue'
import SmoothScroll from './_SmoothScroll.js'
import ScrollHelper from './_ScrollHelper.js'
import ResizeHelper from './_ResizeHelper.js'
import Intersection from './_Intersection.js'
import BackgroundImage from './BackgroundImage.js'
import Vm from './Vm.js'

// import Vue from 'vue';

import Device from './_Device.js'
import './_Utility.js'

// Vue.use(VueYoutube)

// window.jQuery = window.jQuery || (() => ({
//   // these are all methods required by HubSpot
// change: () => {},
// trigger: () => {},
// }));

window.jQuery = require('jquery')

$(() => {
  const $window = $(window);
  const $body = $('body');
  $body.addClass('loaded');


  // ---------------------------------------------------------------
  // scroll effect 
  // ---------------------------------------------------------------
  let windowHeight = window.innerHeight;
  const target = $('.js_scrollTarget')
  if ( target.length ) {
    let scrolltargetPos = target.length ? target.offset().top + target.outerHeight() : 0
    const resizeHelper = new ResizeHelper(() => {
      windowHeight = window.innerHeight;
      scrolltargetPos = target.offset().top + target.height()
    })
    const scrolled = new ScrollHelper(function(){
      const scrolltop = $(window).scrollTop()
      const _windowHeight = target.length ? scrolltargetPos : windowHeight
      $body.toggleClass('scrolled', scrolltop >= _windowHeight );
    });
  }

  // ScrollTrigger --------------------------------------------------
  const trigger = new ScrollTrigger({
    trigger: {
      once: true,
      offset: {
        element: {
          x: 0,
          y: (trigger, rect, direction) => {
            return 0.25
          }
        },
        viewport: {
          x: 0,
          y: (trigger, frame, direction) => {
            return 0.3
          }
        }
      },
    },
  })
  trigger.add('[data-trigger]')

  new Rellax('.rellax', {
    speed: -2,
    center: true,
    wrapper: null,
    round: true,
    vertical: true,
    horizontal: false,
    // breakpoints: [BREAK_POINT, BREAK_POINT, BREAK_POINT]
  });

  // ---------------------------------------------------------------
  // scroll effect 
  // ---------------------------------------------------------------
  // const doctor_modal = new Swiper('.js_modal-doctor', {
  //   slidesPerView: 1,
  //   slidesPerGroup: 1,
  //   spaceBetween: 0,
  //   speed: 400,
  //   noSwiping: true,
  //   allowTouchMove: false,
  //   autoHeight: true,
  //   loop: true,
  //   autoplay: false,
  //   // pagination: {
  //   //   el: '.swiper-pagination',
  //   //   type: 'bullets',
  //   // },
  //   effect: 'fade',
  //   fadeEffect: {
  //     crossFade: true
  //   },
  //   navigation: {
  //     nextEl: '.modal__arrow--next',
  //     prevEl: '.modal__arrow--prev',
  //   },
  //   pagination: {
  //     el: '.advisor-slider__readout',
  //     type: 'fraction',
  //     renderFraction: function (currentClass, totalClass) {
  //       return '<span class="' + currentClass + '"></span>/<span class="' + totalClass + '"></span>';
  //     }
  //   },
  // })

  // const modal = document.getElementById('js_doctor-modal')
  // $('.js_open-doctor-modal').on('click', e => {
  //   const id = e.currentTarget.getAttribute('data-modal-index')
  //   doctor_modal.slideTo(id, 0)
  //   const body = modal.querySelector('.js_doctor-modal-body')
  //   body.scrollTop = 0
  //   modal.classList.add('open')
  // })
  // $('.js_close-doctor-modal').on('click', e => {
  //   console.log(e)
  //   modal.classList.remove('open')
  // })
  // $('.js_modal-ignore').on('click', e => {
  //   e.stopPropagation()
  // })
  
  new Swiper('.js_gallery:not(.js_gallery--backwards)', {
    slidesPerView: "auto",
    speed: 20000,
    noSwiping: true,
    allowTouchMove: false,
    loop: true,
    updateOnWindowResize: false,
    autoplay: {
      delay: 0,
      disableOnInteraction: true,
    },
  })
  new Swiper('.js_gallery--backwards', {
    slidesPerView: "auto",
    speed: 20000,
    noSwiping: true,
    allowTouchMove: false,
    loop: true,
    updateOnWindowResize: false,
    autoplay: {
      reverseDirection: true,
      delay: 0,
      disableOnInteraction: true,
    },
  })



  // const modal_slider = $('.js_modal-doctor')

  // $('.js_open-modal-doctor').on('click', e => {

  //   const media = window.matchMedia('(max-width: 750px)')
  //   if(media.matches) {
  //     const index = $(e.currentTarget).attr('data-slide-index')
  //     document.querySelector('.doctor-modal').scrollTop = 0
  //     modal_slider.toggleClass('active')
  //     tvcm.slideTo(index, 0)
  //   }
  // })
  // $('.js_close-modal-doctor').on('click', e => {
  //   modal_slider.removeClass('active')
  // })




  // smooth scroll ------------------------------------------------------------
  function scrollTo(top){
    $('html,body').animate({ scrollTop: top }, {'easing': 'swing', 'duration': 500});
  }
  function calcScrollTo($el){
    // const offset = $('#nav').outerHeight() || 100;
    const offset = 0;
    if($el.length){
      var to = $el.offset().top
    }else{
      var to = 0;
    }
    return to - offset;
  }
  $('a[href ^= "#"]').on('click', function(e){
    const $this = $(this);
    const id = $this.attr('href');
    if(id === '#') return false;
    const $el = $(id);
    scrollTo(calcScrollTo($el));

    if($this.hasClass('nohash')){
      e.preventDefault();
    }
    e.stopPropagation();
  });

  
});
